<template>
  <div class="container mt-2">
    <div
      class="swal2-icon swal2-success swal2-animate-success-icon mt-5"
      style="display: flex"
    >
      <div
        class="swal2-success-circular-line-left"
        style="background-color: rgb(255, 255, 255)"
      ></div>
      <span class="swal2-success-line-tip"></span>
      <span class="swal2-success-line-long"></span>
      <div class="swal2-success-ring"></div>
      <div
        class="swal2-success-fix"
        style="background-color: rgb(255, 255, 255)"
      ></div>
      <div
        class="swal2-success-circular-line-right"
        style="background-color: rgb(255, 255, 255)"
      ></div>
    </div>
    <h2 class="text-center mt-5">Succès</h2>
    <p class="text-center mt-2" style="font-size: 1.3em">
      Nous vous avons envoyé le lien de votre vidéo par mail
    </p>
  </div>
</template>

<script>
export default {
  name: "email-sent",
  data() {
    return {};
  },
  methods: {},
  computed: {},
  beforeDestroy: {},
  mounted() {},
};
</script>